import { CustomForm } from '../../../../../models/types/CustomForm';

import { FormColumn } from '../../../../UI/Form/FormColumn/FormColumn';

import { Wrapper } from './srRenewSubscriptionDetails.styles';
import { SubscriptionRenewDetailsCommonForm } from '../../Common/SubscriptionRenewDetailsCommonForm/SubscriptionRenewDetailsCommonForm';
import { ProductType } from '../../../../../models/ProductType';

export const SRRenewSubscriptionDetails = ({ disabled }: CustomForm) => (
  <Wrapper>
    <FormColumn>
      <SubscriptionRenewDetailsCommonForm
        disabled={disabled}
        productType={ProductType.SecurityResponse}
      />
    </FormColumn>
  </Wrapper>
);
